const Loader = () => {
  return;
};

export default Loader;
